export default "__VITE_ASSET__dc702881__"